import {
  ChartCurve,
  ChartHorizontalAlign,
  ChartPosition,
  ChartShape
} from '@base/@types/components/Layout/Graphic/Info'

export const getStorageSeries = (data: any[]) => {
  return [
    {
      name: 'Ruptura (%)',
      type: 'line',
      data: data.map(item => item.valor)
    },
    {
      name: '',
      type: 'line',
      data: []
    }
  ]
}

export const storageOptions = (data: any[]) => {
  return {
    chart: {
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 10,
        left: 7,
        blur: 8,
        opacity: 0.2
      },
      toolbar: {
        show: true,
        offsetY: -5,
        offsetX: -26
      }
    },
    colors: ['#60b2ba', 'transparent'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: [3],
      curve: ChartCurve.smooth,
      colors: ['#60b2ba']
    },
    markers: {
      size: 3,
      strokeWidth: 0,
      shape: ChartShape.circle,
      hover: {
        size: 6
      }
    },
    xaxis: {
      labels: {
        rotate: 0
      },
      categories: data.map(item => {
        const date = new Date(item.data)
        const day = date.getUTCDate()
        const month = date.getMonth()
        const year = date.getFullYear()
        if (month < 9) {
          return `${day < 10 ? '0' + day : day}/0${month + 1}/${year}`
        }

        return `${day < 10 ? '0' + day : day}/${month + 1}/${year}`
      }),
      tickAmount: 4
    },
    yaxis: {
      title: {
        text: 'Valores'
      },
      tickAmount: 3,
      labels: {
        formatter: function (val: any) {
          return Number(val).toFixed(1)
        }
      }
    },
    tooltip: {
      shared: false,
      y: [
        {
          formatter: function (y: any) {
            return `${Number(y).toFixed(2)}`
          }
        }
      ]
    },
    legend: {
      floating: true,
      position: ChartPosition.top,
      horizontalAlign: ChartHorizontalAlign.center,
      offsetX: 25,
      offsetY: -3,
      onItemClick: {
        toggleDataSeries: false
      }
    }
  }
}
